// src/components/notifications/NotificationBell.jsx
// Notification bell with unread count and inbox trigger

import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../hooks/useNotifications.ts';
import { useAuthState } from '../../auth/AuthProvider';
import NotificationInbox from './NotificationInbox';

/**
 * @param {object} props
 * @param {string} [props.userRole]
 * @param {number} [props.totalUnread] - External unread count override from useUnifiedNotificationCount.
 */
const NotificationBell = ({ userRole = 'party', totalUnread: externalCount }) => {
  const [showInbox, setShowInbox] = useState(false);
  const { user } = useAuthState();
  const { unreadCount: internalCount } = useNotifications({ userId: user?.uid });
  const unreadCount = externalCount !== undefined ? externalCount : internalCount;

  return (
    <div className="relative">
      <button
        data-testid="notifications.bell"
        onClick={() => setShowInbox(true)}
        className="relative p-2 rounded-lg hover:bg-surface-hover transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
        aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      >
        <Bell className="w-5 h-5 text-text" />
        {unreadCount > 0 && (
          <div className="absolute -top-1 -right-1 bg-primary text-white text-xs rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
            {unreadCount > 99 ? '99+' : unreadCount}
          </div>
        )}
      </button>

      <NotificationInbox
        isOpen={showInbox}
        onClose={() => setShowInbox(false)}
        userRole={userRole}
      />
    </div>
  );
};

export default NotificationBell;